import React, { useEffect } from 'react';

import { getConfigValue } from 'utils/environment';

const UpdatePage = () => {
  useEffect(() => {
    let platform = window?.cordova?.platformId;

    if (!platform) {
      const ua = navigator.userAgent;
      if (/Android/i.test(ua)) {
        platform = 'android';
      } else if (/iPhone|iPad|iPod/i.test(ua)) {
        platform = 'ios';
      }
    }

    let url;
    if (platform === 'android') {
      url = getConfigValue('androidDeepLink');
    } else if (platform === 'ios') {
      url = getConfigValue('iosDeepLink');
    }

    if (url) {
      try {
        const InAppBrowser = (window.cordova as any).InAppBrowser;
        InAppBrowser.open(url, '_blank');
      } catch (e) {
        window.open(url, '_system');
      }
    } else {
      window.location.replace('/');
    }
  }, []);

  return <></>;
};

export default UpdatePage;
